import React, { useEffect, useState } from "react";
import UserTable from "../../components/UserDetailsTable/UserDetailsTable";
import Header from "../../components/Header/Header";
import { getUser, getAllUserForRM } from "../../redux/user/userSlice";
import { useDispatch } from "react-redux";
import AppLoader from "../../components/AppLoader/AppLoader";

interface User {
  id: number;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  mobile: string;
  logInBy: number;
  onboardStatus: number;
  createdAt: string;
  aumUserId: string;
}

const UserDetails: React.FC = () => {
  const [editUser, setEditUser] = useState<User | null>(null);
  const [loader, setLoader] = useState<boolean>(true);
  const [users, setUsers] = useState<User[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortOption, setSortOption] = useState<number>(4);
  const [onboardStatusFilter, setOnboardStatusFilter] = useState<number>(-1);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const dispatch = useDispatch<any>();
  const userType = localStorage?.getItem("userType");

  const handleEdit = (user: User) => {
    setEditUser(user);
  };

  const handleSave = () => {
    if (editUser) {
      setUsers((prevUsers) =>
        prevUsers.map((user) => (user.id === editUser.id ? editUser : user))
      );
      setEditUser(null);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (editUser) {
      setEditUser((prevUser) => ({
        ...prevUser!,
        [name]: value,
      }));
    }
  };

  const handleCancel = () => {
    setEditUser(null);
  };

  const fetchUsers = async (
    pageIndex: number,
    pageSize: number,
    sortBy?: number,
    onboardStatus?: number,
    startDate?: string,
    endDate?: string
  ) => {
    setLoader(true);
    try {
      let response;

      if (userType === "4") {
        response = await dispatch(
          getUser({
            id: 0,
            firstName: "",
            lastName: "",
            userName: "",
            email: "",
            mobile: "",
            logInBy: 0,
            // onboardStatus: 0,
            createdAt: "",
            pageIndex,
            pageSize,
            sortBy,
            onboardStatus,
            startDate,
            endDate,
          })
        );
      } else {
        response = await dispatch(
          getAllUserForRM({
            pageIndex,
            pageSize,
            forRm: userType === "2" ? 1 : userType === "6" ? 0 : -1,
            sortBy,
            onboardStatus,
            startDate,
            endDate,
            search: "",
          })
        );
      }

      console.log("Response payload:", response.payload);

      // const data = response.payload.fdList;
      const data = response.payload.data;
      const totalPages = response.payload.totalPages;
      console.log("total pages", totalPages);
      const currentPage = Math.min(response.payload.pageIndex, totalPages);

      setUsers(data);
      setTotalPages(totalPages);
      setCurrentPage(currentPage);

      console.log("Users data:", data);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setTotalPages(0);
      setCurrentPage(0);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchUsers(
      currentPage,
      pageSize,
      sortOption,
      onboardStatusFilter,
      startDate,
      endDate
    );
  }, [
    dispatch,
    currentPage,
    pageSize,
    sortOption,
    onboardStatusFilter,
    startDate,
    endDate,
  ]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setCurrentPage(newPage + 1);
  };

  const handleRefresh = () => {
    fetchUsers(
      currentPage,
      pageSize,
      sortOption,
      onboardStatusFilter,
      startDate,
      endDate
    );
  };

  const handlePageSizeChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(1); // Reset to first page whenever page size changes
  };

  return (
    <div>
      <AppLoader loading={loader} />
      <UserTable
        users={users}
        editUser={editUser}
        onEdit={handleEdit}
        onSave={handleSave}
        onChange={handleChange}
        onCancel={handleCancel}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        sortBy={sortOption}
        onboardStatus={onboardStatusFilter}
        startDate={startDate}
        endDate={endDate}
        onChangeEndDate={setEndDate}
        onChangeStartDate={setStartDate}
        onChangeOnboardStatus={setOnboardStatusFilter}
        onChangeSortBy={setSortOption}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default UserDetails;
